// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_d9-a";
export var fulfillmentFormRail = "_d9-9";
export var headerTitleRow = "_d9-c";
export var orderDetailsWrapper = "_d9-7";
export var orderLinkTrigger = "_d9-2";
export var paymentInformationGrid = "_d9-h";
export var paymentSummaryColumn = "_d9-i";
export var shipmentContainer = "_d9-b";
export var shipmentDetailsMainPane = "_d9-8";
export var shipmentNavigationCard = "_d9-5";
export var shipmentNavigationRail = "_d9-3";
export var shipmentNavigationRailHeader = "_d9-4";
export var shipmentSummaryFact = "_d9-e";
export var shipmentSummaryGrid = "_d9-d";
export var shipmentSummaryMetadataRow = "_d9-f";
export var shipmentSummaryTags = "_d9-g";
export var shipmentWorkspace = "_d9-0";
export var shipmentWorkspaceContent = "_d9-6";
export var shipmentWorkspaceHeader = "_d9-1";